<template>
	<div class="container">
		<div class="main_box">
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="top_box"
			>
				<div class="go_top" @click="goTop">
					<img src="../../assets/img_public/footer/icon_top.webp" />
					<span>返回顶部</span>
				</div>
			</div>
			<!--块1-->
			<div class="block_1">
				<div class="left">
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="box_1"
						@click="goIndex"
					>
						<img src="../../assets/img_public/logo.webp" />
						<span>宝瑞源生物技术（北京）有限公司</span>
					</div>
					<div
						v-if="navList.length > 0"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="box_2"
					>
						<div v-for="(value, index) in navList" :key="index" v-if="value.route != 'Index'" class="box_2_el">
							<div v-if="value.route == 'Product'">
								<div class="tit" @click="oneNavClick(value)">{{ value.title }}</div>
								<!-- <div class="txt" @click="oneNavClick(value)">解决方案</div>
								<div class="txt" @click="oneNavClick(value)">产品分类</div> -->
							</div>
							<div v-else>
								<div class="tit" @click="oneNavClick(value)">{{ value.title }}</div>
								<template v-if="value.children">
									<div v-for="(value2, index2) in value.children" :key="index2" class="txt" @click="oneNavClick(value2, true)">{{ value2.title }}</div>
								</template>
							</div>
						</div>
					</div>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="box_3"
					>
						<van-icon name="location" color="#999999" size="22" style="top:4px;" />
						<span>北京市房山区窦店镇中心路8号</span>
					</div>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="box_3"
					>
						<van-icon name="location" color="#999999" size="22" style="top:4px;" />
						<span style="font-size: 20px;">
							5900 Windward Pkwy. Alpharetta, GA 30005 USA<span style="font-size: 18px;">（国际）</span>
						</span>
					</div>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="box_4"
					>
						<div class="tit">友情链接</div>
						<div class="txt">
							<a href="https://cordx.com/" target="_blank">Cordx Union集团官网</a>
						</div>
						<div class="txt">
							<a href="https://cn.coretests.com/" target="_blank">北京库尔科技有限公司</a>
						</div>
						<div class="txt">
							<a href="https://bonore.com/" target="_blank">保诺塑业（北京）有限公司</a>
						</div>
					</div>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="box_5"
					>
						<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17072452号-2</a>
						&ensp;&ensp;<a href="https://abiores.com.cn/20250312.jpeg" target="_blank">(京)网药械信息备字（2025）第 00050 号</a>
					</div>
				</div>
				<div class="right">
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="code_box"
					>
						<img src="../../assets/img_public/footer/qrcode.webp" />
						<div class="tit">关注宝瑞源</div>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
	</div>
</template>

<script>
	export default {
		components: {
			//
		},
		data() {
			return {
				navList: [],
				lang: sessionStorage.getItem('lang')
			}
		},
		created() {
			let that = this;
			if(sessionStorage.getItem('navList')) {
				that.navList = JSON.parse(sessionStorage.getItem('navList'));
			}
		},
		mounted() {
			let that = this;
		},
		watch: {
			//
		},
		methods: {
			//一级导航点击
			oneNavClick(value, value2) {
				let that = this;
				if(that.$route.path != value.url) {
					if(value2) {
						if(that.$route.name === value.route) {
							that.$router.push({ path: value.url, });
							window.location.reload();
						}else {
							if(that.$route.path != value.url) {
								that.$router.push({ path: value.url, });
							}
						}
					}else {
						that.$router.push({ path: value.url });
					}
				}else {
					window.location.reload();
				}
			},
			//滚动到顶部
			goTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			},
			//点击首页
			goIndex() {
				if (this.$route.path != '/') {
					this.$router.push({
						path: '/'
					});
				} else {
					window.location.reload();
				}
			},
		}
	}
</script>

<style lang="less" scoped>
.main_box {
	color: #333333;
	padding: 120px 0;
	background-color: #EEEEEE;
	.top_box{
		position: relative;
		width: 1200px;
		margin: 0 auto;
		.go_top{
			position: absolute;
			top: 0;
			right: 0;
			cursor: pointer;
			span{
				position: relative;
				top: 15px;
				left: 0px;
				font-size: 20px;
				font-weight: bold;
			}
			img{
				width: 60px;
			}
		}
	}
	.block_1{
		display: flex;
		align-items: end;
		width: 1200px;
		margin: 0 auto;
		.right{
			width: auto;
			position: relative;
			.code_box{
				.tit{
					padding-top: 15px;
					font-size: 22px;
					text-align: center;
				}
				img{
					width: 240px;
				}
			}
		}
		.left{
			flex: 1;
			.box_5{
				padding-top: 10px;
				font-size: 18px;
				color: #666666;
				a{
					color: #666666;
					font-size: 18px;
				}
			}
			.box_4{
				.txt{
					display: inline-block;
					margin-left: 40px;
					a{
						color: #333333;
						font-size: 18px;
					}
				}
				.tit{
					display: inline-block;
					font-size: 20px;
					font-weight: bold;
				}
			}
			.box_3{
				padding-bottom: 8px;
				span{
					display: inline-block;
					padding-left: 10px;
					font-size: 18px;
				}
			}
			.box_2{
				padding: 40px 0;
				.box_2_el{
					display: inline-table;
					margin-right: 60px;
					cursor: pointer;
					.txt{
						padding-bottom: 8px;
						font-size: 18px;
						text-align: center;
					}
					.tit{
						padding-bottom: 18px;
						font-size: 20px;
						font-weight: bold;
					}
				}
			}
			.box_1{
				display: inline-block;
				cursor: pointer;
				span{
					position: relative;
					top: -3px;
					left: 30px;
					font-size: 26px;
					font-weight: bold;
				}
				img{
					width: 200px;
					position: relative;
					top: -13px;
				}
			}
		}
	}
}
</style>